export default {
    name: 'AppFooter',    
    created() { 

        
    },
    data() {
        return {            
        };
    },
  
    methods: {
        href(url) {
            if (url !== this.$router.currentRoute.path) {
                this.$router.push(url);
            }
        },
    }    
}
